/**
 * Shared copy for create/add buttons disabled because the plan quota is full.
 */
export function planLimitReachedMessage(resourceLabel, upgradeHref = '/app/subscribe') {
	const label = resourceLabel || 'Plan'
	return `${label} limit reached. Please <a class="underline hover:text-white" target="_blank" href="${upgradeHref}">upgrade your plan</a> to create more.`
}
